export default "__VITE_ASSET__V8Mh_nf5__"